import React from 'react'
import PropTypes from 'prop-types'
import PlaceHolder from '@assets/svgs/placeholder.svg'
import './ProductImage.module.scss'
import 'lazysizes'
// import a plugin
import 'lazysizes/plugins/parent-fit/ls.parent-fit'

const ProductImage = ({ src, alt }) => (
  <img data-src={src || PlaceHolder} alt={alt} styleName='image' className='lazyload' />
)

ProductImage.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string.isRequired
}

export default ProductImage



// WEBPACK FOOTER //
// ./src/components/ProductImage/ProductImage.js